import { Calendar } from "lucide-react";

export function EventEmptyState({
  title,
  message,
}: {
  title: string;
  message: string;
}) {
  return (
    <section className="px-4 py-16 text-center sm:px-6">
      <Calendar className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />
      <p className="font-medium text-foreground">{title}</p>
      <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{message}</p>
    </section>
  );
}
